import { continueLaterLocalization } from '@vwfs-its/sf-sac-frontend'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const localization = continueLaterLocalization({
  locale: 'uk',
  brandName: { BRAND_NAME: process.env.REACT_APP_WEBSITE_BRAND },
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  })

i18n.addResourceBundle('en', 'sf-sac', localization, true, true)

export default brandName => {
  return new Promise(res => {
    const namespaces = [
      'page',
      'validation',
      'form',
      'landingPage',
      'app',
      'error',
      'data',
      'shoppingCart',
      'alreadySubmitted',
      'summary',
      'confirmation',
      'contact',
      'saveAndContinue',
      'expiredLink',
      'payment',
      'paymentAlreadyCompleted',
    ]
    Promise.all(
      namespaces.map(item => {
        return import(`../../resources/base/content/${item}.json`)
          .then(module => {
            i18n.addResourceBundle('en', item, module.default, true, true)
          })
          .then(() => {
            /**
             * Request brand-specific resources and override (using deep) the
             * resources for specific brand. Make sure to chain those to avoid
             * race conditions.
             */
            import(`../../resources/${brandName}/content/${item}.json`)
              .then(module => {
                i18n.addResourceBundle('en', item, module.default, true, true)
              })
              .catch(() => {})
          })
      })
    ).then(res)
  })
}
